import { useEffect, useRef, useState } from "react";

export function useCountdown(seconds, active, onExpire) {
  const [left, setLeft] = useState(seconds);
  const cb = useRef(onExpire);
  const leftRef = useRef(seconds);
  cb.current = onExpire;

  useEffect(() => {
    if (!active) return undefined;
    const end = Date.now() + leftRef.current * 1000;
    const id = setInterval(() => {
      const l = Math.max(0, Math.ceil((end - Date.now()) / 1000));
      leftRef.current = l;
      setLeft(l);
      if (l <= 0) { clearInterval(id); cb.current(); }
    }, 200);
    return () => clearInterval(id);
  }, [active]);

  return left;
}
